<template>
  <div class="home">

    <section id="home" class="main">
      <div class="container-fluid">
        <div class="row baner">
          <div class="col-12 mb-md-5 text-center">
            <h1 class="baner__title">
              Change in Every Quarter
            </h1>
            <p class="baner__subtitle">
              At Q5 our expertise is in helping organisations transform.<br>
              How do organisations get ready for the future, when the future is now?
            </p>
            <div class="baner__form d-none d-md-block">
              <input @keyup.enter="validateCode" v-model="evaluationCode" class="baner__input"
                type="text" placeholder="Enter Organomyx code" >
              <button @click="validateCode" class="baner__button custom-btn custom-btn--green">
                <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
                <span v-if="!processing">Get started</span>
              </button>
              <alert class="baner__error" :success="alert.success" :error="alert.error"></alert>
            </div>
            <a class="appstore" rel="nofollow"
              href="https://itunes.apple.com/us/app/q5-organomyx/id1437060391" target="_blank">
              <img src="~assets/img/appstore.png" alt="">
            </a>
          </div>
        </div>
        <div class="row check-it">
          <div class="col-12 text-center">
            <h1 class="baner__title baner__title--demo">
              <div @click="goToDemo" class="baner__link">
                Organomyx Preview
                <img src="~assets/img/arrow_right_icon.svg" alt="">
              </div>
            </h1>
            <p class="baner__subtitle pr-md-5 pt-2 pt-md-0">
              Take a tour of our Organomyx assessment
            </p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row institutions">
          <div class="col-12 d-md-none text-center institution">
            <img class="institution__img img-fluid" src="~assets/img/office-sydney.png">
            <h5 class="institution__place">SYDNEY</h5>
          </div>
          <div class="col-12 d-md-none text-center institution">
            <img class="institution__img img-fluid" src="~assets/img/office-new-york.png">
            <h5 class="institution__place">NEW YORK</h5>
          </div>
          <div class="col-12 d-md-none text-center institution">
            <img class="institution__img img-fluid" src="~assets/img/office-hong-kong.png">
            <h5 class="institution__place">HONG KONG</h5>
          </div>
          <div class="col-12 d-md-none text-center institution">
            <img class="institution__img img-fluid" src="~assets/img/office-london.png">
            <h5 class="institution__place">LONDON</h5>
          </div>

          <div class="col d-none d-md-block institution">
            <img class="institution__img img-fluid" src="~assets/img/offices-big-2.png">
          </div>
        </div>
      </div>
    </section>

    <section id="how-it-works" class="how-it-works">
      <div class="container">

        <div class="row">
          <div class="col-12 mb-lg-3 text-center">
            <h1 class="section-header p-0 text-center">
              Exploring Connective Organisations
            </h1>
            <p class="section-text section-text--mw-desktop">
              We're passionate about helping organisations to transform.<br>
              Our Organomyx tool helps explore the characteristics of organisations that
              are thriving even as the pace of change accelerates.
            </p>
          </div>
          <div class="col-12 text-center">
            <img class="img-fluid first__office-image" src="~assets/img/section-q5.jpg">
          </div>
          <div class="col-12 text-center">
            <a class="appstore" rel="nofollow"
              href="https://itunes.apple.com/us/app/q5-organomyx/id1437060391" target="_blank">
              <img src="~assets/img/appstore.png" alt="">
            </a>
          </div>
        </div>

      </div>
    </section>

    <!-- <section class="details">
      <div class="container">

        <div class="row no-gutters explore">
          <div class="col-12 col-md-6">
            <img
              class="explore__image img-fluid"
              v-if="blocks[3]"
              :src="blocks[3].photo">
          </div>

          <div class="col-12 col-md-6 explore__container">
            <h3
              class="explore__title"
              v-if="blocks[3]">
              {{ blocks[3].title }}
            </h3>
            <img class="explore__line" src="~assets/img/line-left.png">
            <p class="explore__text" >
            </p>
              <span
                v-if="blocks[3]"
                v-html="blocks[3].content"></span>
              <span class="evaluate__text--green" @click="showMore = true" v-if="!showMore">Read more...</span>
          </div>
          <transition name="fade">
            <div v-if="showMore" class="col-12">
              <p class="explore__text"
                v-if="blocks[3]"
                v-html="blocks[3].hidden">
              </p>
              <div class="row text-center">
                <div
                  v-for="quality in qualities"
                  :key="quality.definition.cms_quality_id"
                  class="col-12 col-md-1-5 explore__icon-container">
                  <img class="explore__icon" :src="quality.thumb" alt="">
                  <p class="explore__icon-title">
                    {{ quality.name }}
                  </p>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="row no-gutters evaluate">
          <div class="col-12 col-md-6 evaluate__container">
            <h3
              class="evaluate__title"
              v-if="blocks[2]">
              {{ blocks[2].title }}
            </h3>
            <img class="evaluate__line" src="~assets/img/line-right.png">
            <p
              class="evaluate__text"
              v-if="blocks[2]"
              v-html="blocks[2].content"></p>
          </div>
          <div class="col-12 col-md-6">
            <img
              class="evaluate__image img-fluid"
              v-if="blocks[2]"
              :src="blocks[2].photo">
          </div>
        </div>

        <div class="row no-gutters counters d-none">
          <div class="col-12 col-md-4 counters__item">
            <h3 class="counters__number">X</h3>
            <p class="counters__text">Client engagements</p>
          </div>
          <div class="col-12 col-md-4 counters__item">
            <h3 class="counters__number">Y</h3>
            <p class="counters__text">Countries</p>
          </div>
          <div class="col-12 col-md-4 counters__item">
            <h3 class="counters__number">Z</h3>
            <p class="counters__text">Evaluations</p>
          </div>
        </div>
        <div id="benefits" class="row benefits mb-0 pb-0">
          <div class="col-12 offset-lg-1 col-lg-10">
            <h2
              class="benefits__title"
              v-if="blocks[1]">
              {{ blocks[1].title }}
              <img class="benefits__icon" src="~assets/img/icon-done.svg" alt="">
            </h2>
          </div>
        </div>
        <div
          class="row benefits pt-0"
          v-if="blocks[1]"
          v-html="blocks[1].content"></div>
      </div>
    </section> -->

    <!-- <section class="client-engagments d-none">
      <div class="container">
        <div class="row no-gutters client-engagments__description-container">
          <div class="col-12 col-md-6 client-engagments__description">
            <h2
              class="section-header section-header--reverse section-header--small"
              v-if="blocks[3]">
              {{ blocks[3].title }}
            </h2>
            <p
              class="client-engagments__description-text"
              v-if="blocks[3]"
              v-html="blocks[3].content"></p>
          </div>
          <div class="col-12 col-md-6 client-engagments__img-container">
            <img class="client-engagments__img img-fluid"
              src="~assets/img/section-client-engagements.jpg">
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="success-stories" class="case-studies">
      <div class="container">
        <div class="row no-gutters case-studies__container ">
          <div class="col-12 col-md-6 col-lg-7 case-studies__list">
            <div class="case-studies__item case-studies__item--1">
              <img class="img-fluid" src="~assets/img/study-case.jpg">
              <div class="case-studies__item-description">
                <h5 class="case-studies__item-title">The Power of Purpose</h5>
                <p
                  v-if="caseStudies[0]"
                  class="case-studies__item-text">
                  {{ caseStudies[0].improved }}
                </p>
                <router-link :to="{ name: 'purpose-case' }" class="custom-btn custom-btn--case">
                  Read case study
                </router-link>
              </div>
            </div>
            <div class="case-studies__item case-studies__item--2">
              <img class="img-fluid" src="~assets/img/study-case.jpg">

              <div class="case-studies__item-description">
                <h5 class="case-studies__item-title">The Power of Ecosystem</h5>
                <p
                  class="case-studies__item-text"
                  v-if="caseStudies[2]">
                  {{caseStudies[2].improved}}
                </p>
                <router-link :to="{ name: 'ecosystem-case' }" class="custom-btn custom-btn--case">
                  Read case study
                </router-link>
              </div>

            </div>
            <div class="case-studies__item case-studies__item--3">
              <img class="img-fluid" src="~assets/img/study-case.jpg">
              <div class="case-studies__item-description">
                <h5 class="case-studies__item-title">The Power of Adaptability</h5>
                <p
                  class="case-studies__item-text"
                  v-if="caseStudies[1]">
                  {{ caseStudies[1].improved }}
                </p>
                <router-link :to="{ name: 'adaptability-case' }" class="custom-btn custom-btn--case">
                  Read case study
                </router-link>
              </div>

            </div>
            <div class="case-studies__item case-studies__item--4">
              <img class="img-fluid" src="~assets/img/study-case.jpg">
              <div class="case-studies__item-description">
                <h5 class="case-studies__item-title">The Power of Empowerment</h5>
                <p
                  class="case-studies__item-text"
                  v-if="caseStudies[3]">
                  {{ caseStudies[3].improved }}
                </p>
                <router-link :to="{ name: 'empowerment-case' }" class="custom-btn custom-btn--case">
                  Read case study
                </router-link>
              </div>

            </div>
            <div class="case-studies__item case-studies__item--5">
              <img class="img-fluid" src="~assets/img/study-case.jpg">

              <div class="case-studies__item-description">
                <h5 class="case-studies__item-title">The Power of Leadership</h5>
                <p
                  class="case-studies__item-text"
                  v-if="caseStudies[4]">
                  {{ caseStudies[4].improved }}
                </p>
                <router-link :to="{ name: 'leadership-case' }" class="custom-btn custom-btn--case">
                  Read case study
                </router-link>
              </div>

            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-5 case-studies__description">
            <h3
              class="case-studies__title"
              v-if="blocks[0]">
              {{blocks[0].title}}
            </h3>
            <img class="case-studies__line d-none d-lg-block" src="~assets/img/line-white.png">
            <p
              v-if="blocks[0]"
              v-html="blocks[0].content">
            </p>
          </div>
        </div>
      </div>
    </section> -->

    <section id="contact" class="contact">
      <div class="container">
        <!-- <div class="row no-gutters contact__description-container">
          <div class="col-12 col-md-6 contact__description">
            <h2
              class="section-header section-header--underlined section-header--small"
              v-if="blocks[4]">
              {{ blocks[4].title }}
            </h2>
            <img class="contact__line d-none d-xl-block" src="~assets/img/line-right.png">
            <p
              class="contact__description-text"
              v-if="blocks[4]"
              v-html="blocks[4].content">
            </p>
          </div>
          <div class="col-12 col-md-6">
            <img
              class="img-fluid"
              v-if="blocks[4]"
              :src="blocks[4].photo">
          </div>
        </div> -->
        <div class="row contact__icons-container">
          <div class="col-12 col-md-4 contact__icon">
            <img class="contact__icon-image" src="~assets/img/icon-mail.svg">
            <p class="contact__icon-text">info@q5partners.com</p>
          </div>
          <div class="col-12 col-md-4 contact__icon">
            <img class="contact__icon-image" src="~assets/img/icon-phone.svg">
            <p class="contact__icon-text">
              <!-- <span
                v-for="(office, index) in offices"
                :key="index">{{ office.city }}: {{ office.phone }}<br></span> -->
            </p>
          </div>
          <div class="col-12 col-md-4 contact__icon">
            <img class="contact__icon-image" src="~assets/img/icon-link.svg">
            <p class="contact__icon-text">www.q5partners.com</p>
          </div>
        </div>
      </div>
    </section>

    <section class="offices">
      <div class="container">
        <div class="row no-gutters">
          <!-- <div
            v-for="(office, index) in offices"
            :key="index"
            class="col-12 col-md-3 offices__item">
            <img
              class="img-fluid offices__image d-none d-md-block"
              :src="office.photo">
            <img class="img-fluid offices__image d-md-none" src="~assets/img/london-mobile.png">
            <div class="offices__description">
              <h5>{{ office.city }}</h5>
              <p v-html="office.address"></p>
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <div
      class="baner__form floating-button d-none d-md-block"
      ref="floatingButton">
      <img
        v-on:click="toggleButton"
        src="~assets/img/arrow_right.svg"
        class="floating-button__icon"
        ref="floatingButtonIcon"/>
      <input
        v-model="evaluationCode"
        @keyup.enter="validateCode"
        class="baner__input floating-button__input"
        type="text">
      <span
        v-show="!evaluationCode"
        class="floating-button__placeholder"
        ref="floatingButtonPlaceholder">
        Enter your<br> Organomyx code
      </span>
      <button
        @click="validateCode"
        class="baner__button floating-button__button custom-btn custom-btn--green">
        <clip-loader
          :loading="processing"
          :color="'white'"
          :size="'17px'"></clip-loader>
        <span
          v-if="!processing">
          Get started
        </span>
      </button>
      <alert
        class="baner__error floating-button__error"
        :success="alert.success"
        :error="alert.error"></alert>
    </div>

    <app-footer/>
  </div>
</template>

<script>
// API
import organizationsApi from '@/api/organizations';
// Components
import Alert from '@/components/Helpers/Alert';
import AppFooter from '@/components/Footer';
// Mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert, AppFooter },
  mixins: [alert],
  props: ['sectionScroll'],
  data() {
    return {
      evaluationCode: '',
      processing: false,
      showMore: false,
      blocks: [],
      offices: [],
      caseStudies: [],
      qualities: [],
    };
  },
  // created() {
  //   homepageApi.getHomepage()
  //     .then((response) => {
  //       this.offices = response.data.offices;
  //       this.blocks = response.data.blocks;
  //     })
  //     .catch(() => {
  //       this.$message.error('Something went wrong, try again later.');
  //     });
  //   homepageApi.getAllCaseStudies()
  //     .then((response) => {
  //       this.caseStudies = response.data;
  //     })
  //     .catch(() => {
  //       this.$message.error('Something went wrong, try again later.');
  //     });
  //   homepageApi.getQualities()
  //     .then((response) => {
  //       this.qualities = response.data;
  //     })
  //     .catch(() => {
  //       this.$message.error('Something went wrong, try again later.');
  //     });
  // },
  mounted() {
    if (this.sectionScroll) {
      this.$scrollTo(this.sectionScroll);
    }
  },
  methods: {
    validateCode() {
      this.clearAlerts();
      this.processing = true;
      organizationsApi.validate({ evaluation_code: this.evaluationCode })
        .then(() => {
          this.processing = false;
          this.alert.success = 'Success!';
          this.$router.push({ name: 'start', params: { id: this.evaluationCode } });
        }).catch((data) => {
          this.processing = false;
          this.alert.error = data.response.data.errors.Organization[0];
        });
    },
    goToDemo() {
      this.$store.commit('clearDemoData');
      this.$router.push({ name: 'demoSections' });
    },
    toggleButton() {
      const refs = this.$refs;
      refs.floatingButtonIcon.classList.toggle('rotate3d');
      refs.floatingButton.classList.toggle('translate');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Home/Index.vue